import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "overlay" }
const _hoisted_2 = { class: "playground" }
const _hoisted_3 = {
  key: 0,
  class: "innerground"
}
const _hoisted_4 = { class: "lobby" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h1", null, "Lobby", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "maxChar" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Anleitung"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "Das Spiel funktioniert auf Vertrauensbasis, ein paralleler Kommunikationskanal zwischen den Spielern wird vorausgesetzt."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" In das nebenstehende Feld müssen eine Spiel ID und ein Spielername eingegeben werden. Die Spiele ID muss mit der ihrer Mitspieler übereinstimmen. In der oberen Leiste finden Sie Knöpfe, um das Spiel zu übernehmen und den Spielmodus auszusuchen. Um eine Karte zu spielen oder mit einer im Stock auszutauschen klicken sie auf die Karte. Um den Stich mitzunahmen, klicken Sie auf den Stich. An der Seite wird Ihnen in orange angezeigt, welcher Spieler dran ist. Sie können das Spiel mit dem Knopf \"Neues Spiel\" zurücksetzen, der Computer gibt dann neu. ")
  ]),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("h2", null, "Datenschutz"),
  /*#__PURE__*/_createElementVNode("p", null, " Mit dem Spielen auf dieser Website stimmen Sie zu, dass ihr Spielername sowie ihre eindeutige Spieler-ID als Cookie gespeichert wird. ")
], -1)
const _hoisted_7 = {
  key: 1,
  class: "innerground"
}
const _hoisted_8 = { class: "middle" }
const _hoisted_9 = { class: "lobby" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { id: "container" }, [
  /*#__PURE__*/_createElementVNode("canvas", { id: "canvas" })
], -1)

import { onMounted, reactive } from "vue";
import OverlayComponent from "./components/OverlayComponent.vue"
import axios from 'axios'
import HandComponent from "./components/HandComponent.vue";
import StockComponent from "./components/StockComponent.vue";
import StichComponent from "./components/StichComponent.vue"
import { store } from "@/main"
import { GameMode, GameStage } from "./GameEnums";
import Cookies from "js-cookie"


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const state = store
const newGameId = reactive({ id: "", name: "" })

onMounted(() => {
  console.log("Mounted")

  const gameId = window.location.hash.split("?")[0].substring(1)
  store.game.setGameId(gameId)

  if (gameId === undefined || gameId == "") {
    // window.alert("Not a valid game id")
    // newGameId.id 
  } else {
    initialze(gameId)
  }

  // const resizeHandler = () => {
  //   helper.setDim(innerWidth, innerHeight * 0.8)
  //   frame.width = innerWidth
  //   frame.height = innerHeight * 0.8
  //   game.updateCanvas()
  // }

  // window.onresize = resizeHandler

})

const initialze = (gameId: string) => {
  
  const sec = window.location.protocol === "https:"
  const websocketProtocol = sec ? "wss://" : "ws://"
  const wsString = websocketProtocol + window.location.host
  console.log("Trying connection to " + wsString)
  store.game.setOrigin(wsString)

  const name = Cookies.get("name")
  const oldGameString = Cookies.get("game")


  store.game.onStateChange = () => {
    const game = store.game
    state.stage = game.getStage()
    state.turn = game.getTurn()
    state.playing = game.getPlaying()
    state.playersCount = game.getPlayersCount()
    state.table = game.getTable()
    state.players = game.getPlayers()
    state.mode = game.getMode()
  }

  if (oldGameString != undefined) {
    const oldGame = JSON.parse(oldGameString)
    if (oldGame != undefined && oldGame.gameId == gameId) {
      console.log("Restore old game...")
      state.game.setGameId(oldGame.gameId)
      state.game.setPlayerToken(oldGame.playerToken)
      state.lobby = false
      return
    }
  }

  axios.get("/game/get/" + gameId + "?name=" + name)
    .then(data => {
      state.playerToken = data.data
      store.game.setPlayerToken(state.playerToken)
      state.stage = store.game.getStage()

      Cookies.set("game", JSON.stringify({ gameId: gameId, playerToken: state.playerToken }))

      store.lobby = false
    })
    .catch((err) => {
      window.alert(err.response.data.cause)
    })
}

const startGame = () => {
  Cookies.set("name", newGameId.name)
  window.location.replace("/#" + newGameId.id)
  window.location.reload()
}

const doneStock = (mode: GameMode) => {
  if (!store.game.hasLegalHand()) {
    window.alert("Du brauchst 10 Karten um zu spielen!")
    return
  }
  store.game.doneChoosingGame(mode)
}

const doneReizen = () => {
  store.game.doneReizen()
  state.stage = store.game.getStage()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(OverlayComponent, {
      stage: _unref(state).stage,
      playerToken: _unref(state).playerToken,
      playing: _unref(state).playing,
      onDoneStock: _cache[0] || (_cache[0] = (mode) => doneStock(mode)),
      onDoneReizen: doneReizen,
      onReset: _cache[1] || (_cache[1] = ($event: any) => (_unref(state).game.reset())),
      turn: _unref(state).turn,
      playersCount: _unref(state).playersCount,
      mode: _unref(state).mode
    }, null, 8, ["stage", "playerToken", "playing", "turn", "playersCount", "mode"]),
    _createElementVNode("div", _hoisted_2, [
      (_unref(store).lobby)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Spiel ID",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((newGameId.id) = $event))
                }, null, 512), [
                  [_vModelText, newGameId.id]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Spieler Name",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newGameId.name) = $event))
                }, null, 512), [
                  [_vModelText, newGameId.name]
                ]),
                _createElementVNode("input", {
                  type: "submit",
                  value: "starten",
                  onClick: startGame
                })
              ])
            ]),
            _hoisted_6
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("a", null, "Spieler: " + _toDisplayString(_unref(state).playersCount), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).players, (p) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: p.token,
                    class: _normalizeClass(["player", { activePlayer: p.turn }])
                  }, _toDisplayString(p.name), 3))
                }), 128))
              ])
            ]),
            (_unref(state).stage == _unref(GameStage).SPIEL)
              ? (_openBlock(), _createBlock(StichComponent, {
                  key: 0,
                  cards: _unref(state).table.stich
                }, null, 8, ["cards"]))
              : _createCommentVNode("", true),
            (_unref(state).stage == _unref(GameStage).STOCK && _unref(state).playing)
              ? (_openBlock(), _createBlock(StockComponent, {
                  key: 1,
                  cards: _unref(state).table.stock
                }, null, 8, ["cards"]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createVNode(HandComponent, {
      cards: _unref(state).table.hand
    }, null, 8, ["cards"]),
    _hoisted_10
  ]))
}
}

})